import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <div className="pt-8 pb-6 px-4 max-w-5xl mx-auto" data-id="element-100">
      <div className="text-center mb-6" data-id="element-101">
        <div className="inline-block bg-red-50 border-2 border-red-500 rounded-lg px-4 py-2 font-body font-bold text-red-600 mb-4 text-sm" data-id="element-102">
          🧠 PARA PSICÓLOGOS QUE DOMINAN LA TEORÍA, PERO TEMEN LA PRÁCTICA
        </div>

        <h1 className="font-display text-brand-primary font-bold tracking-tight mb-6 text-[38px] md:text-5xl leading-tight" data-id="element-103">
          DEJA DE IMPROVISAR Y EMPIEZA A EJERCER CON AUTORIDAD.
        </h1>
      </div>

      <div className="my-6 flex justify-center" data-id="element-104">
        <img src="https://cdn.magicpatterns.com/uploads/1SU1uEdpnodP9jxY64bF6T/mockup-removebg-preview_(1).png" alt="PSICÓLOGO EN ACCIÓN" width="500" height="500" fetchPriority="high" loading="eager" decoding="sync" className="w-full max-w-xl" data-id="element-105" />
      </div>

      <div className="text-center max-w-3xl mx-auto" data-id="element-106">
        <h2 className="font-display text-brand-accent text-xl md:text-2xl font-semibold mb-6 leading-relaxed" data-id="element-107">
          Pasa de la inseguridad del recién graduado a la autoridad de un
          profesional con consulta privada. El sistema integral para abrir,
          captar y blindar tu práctica desde el primer paciente.
        </h2>

        <div className="bg-brand-accent/10 border-2 border-brand-accent rounded-lg p-4 mb-6" data-id="element-108">
          <p className="font-body text-brand-primary font-bold text-lg mb-2" data-id="element-109">
            📦 6 TOMOS + 200 PÁGINAS + 3 BONOS + PACK LEGAL
          </p>
          <p className="font-body text-brand-text text-sm" data-id="element-110">
            Sin síndrome del impostor • Sin improvisar • Sin depender de nadie
          </p>
        </div>

        <div className="flex items-center justify-center gap-3 mb-6 text-sm flex-wrap" data-id="element-111">
          <div className="flex text-brand-accent" data-id="element-112">⭐⭐⭐⭐⭐</div>
          <span className="font-body font-bold text-brand-primary" data-id="element-113">4.9/5</span>
          <span className="text-brand-textMuted" data-id="element-114">·</span>
          <span className="font-body text-brand-text font-semibold" data-id="element-115">
            +500 reseñas
          </span>
          <span className="text-brand-textMuted" data-id="element-116">·</span>
          <span className="font-body text-red-600 font-bold" data-id="element-117">
            🔥 38 compraron HOY
          </span>
        </div>

        <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-primary font-body font-bold text-xl md:text-2xl py-4 px-10 rounded-lg transition-all hover:shadow-gold w-full md:w-auto mb-3 animate-pulse" data-id="element-118">
          🚀 QUIERO EL SISTEMA AHORA
        </button>

        <p className="text-brand-textMuted text-xs" data-id="element-119">
          ⏰ Precio de lanzamiento • Sube pronto
        </p>
      </div>
    </div>;
}